import styled from "styled-components";

export const SmallButton = styled.span`
	background: #0971A2;
	border-radius: 5px;
	font-size: 11px;
    padding: 0.5px 5px 0.5px 5px;
	font-weight: 500;
	color: #FFFFFF;
	height: 14px;
    line-height: normal;
`;